import { CLEAN_SEARCH, DISPATCH_SEARCH } from './searchTypes';

export const DispatchSearch = (searchValue) => {
  return (dispatch) => {
    dispatch({
      type: DISPATCH_SEARCH,
      payload: searchValue,
    });
  };
};

export const ClearSearch = () => {
  return (dispatch) => {
    dispatch({
      type: CLEAN_SEARCH,
    });
  };
};
